import React, { useEffect, useState, FC } from "react";
import { App, Button, Modal, Tree } from "antd";
import { User, UserPermissionEnum } from "@/types/user";
import { isString } from "lodash";
import { useTranslation } from "react-i18next";
import { userUpdatePermission } from "@/apis/user";

interface TreeData {
  title: string;
  key: UserPermissionEnum | string;
  children?: Array<TreeData>;
}

interface PermissionProps {
  user: User;
  orgId: null | string;
  treeData: Array<TreeData>;
  defaultPermission?: Array<UserPermissionEnum>;
  handleChange?: (data: Array<UserPermissionEnum>) => void;
  title: string;
  disabled?: boolean;
}

const Permission: FC<PermissionProps> = ({
  user,
  orgId,
  treeData,
  defaultPermission = [],
  handleChange,
  title,
  disabled
}) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const [checkedKeys, setCheckedKeys] = useState<Array<UserPermissionEnum>>(defaultPermission);
  const [selectedKeys, setSelectedKeys] = useState<Array<React.Key>>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
console.log({treeData});

  useEffect(() => {
    const permissions = (user.permissions ?? []).filter(item => item.orgId === orgId).map(item => item.permission)
    if (permissions && permissions?.length > 0) {
      const newList = [...permissions];
      defaultPermission.forEach((item) => { !newList.includes(item) && newList.push(item) });
      setCheckedKeys(newList);
    }
  }, [user]);

  const handleOk = () => {
    setLoading(true);
    const keys = checkedKeys.filter((keys) => !isString(keys));

    userUpdatePermission(user.id, { orgId, permissions: keys })
      .then((res) => {
        if(res.body){
          notification.success({ placement: 'top',message: t('org.authSetSuccess')})
          handleChange && handleChange(keys)
          setOpen(false)
        }
      })
      .catch((err) => {
          notification.error({ placement: 'top',message: t('org.authSetFailed')})
      })
      .finally(() => {
        setLoading(false)
      })
  };

  return (
    <>
      <Button type="link" disabled={disabled} onClick={() => setOpen(true)}>
        {t("org.setPermissions")}
      </Button>
      <Modal
        confirmLoading={loading}
        title={title}
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => handleOk()}
      >
        <div style={{ maxHeight: '60vh', overflow: 'scroll' }}>
          <Tree
            checkable
            onCheck={(val) => setCheckedKeys(val as UserPermissionEnum[])}
            checkedKeys={checkedKeys}
            onSelect={setSelectedKeys}
            selectedKeys={selectedKeys}
            treeData={treeData}
            defaultExpandAll
          />
        </div>
      </Modal>
    </>
  );
};

export default Permission;
